export default __webpack_public_path__ + "static/media/3_size_type02_unselected_icon.a3d5f971.jpg";